import SidebarAdmin from "../../components/SidebarAdmin/SidebarAdmin";
import { Outlet } from "react-router";
import AdminHeader from "../../components/AdminHeader/AdminHeader";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { fetchNotifications } from "../../redux/actions/notificationActions";

const AdminPanel = () => {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);
  const notifications = useSelector((state) => state.notifications.items);
  const loading = useSelector((state) => state.notifications.loading);

  useEffect(() => {
    if (token) {
      dispatch(fetchNotifications(token));  // Dispatch fetchNotifications action
    }
  }, [dispatch, token]);

  return (
    <div className="flex w-full min-h-screen">
      <SidebarAdmin />
      <div className="flex flex-col items-center flex-grow bg-white">
        {/* HEADER */}
        <div className="h-[64px] w-full flex items-center justify-end">
          <AdminHeader notifications={notifications} loading={loading} />
        </div>
        <div className="w-11/12">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdminPanel;
